/**
 * ce-card-hover — hover flip to the second product image on ce-product-card.
 *
 * Matches the behaviour Horizon's own card already has on the collection
 * and search grids (settings.show_second_image_on_hover), which our
 * lightweight homepage card did not, so hover did nothing on the whole
 * homepage. See snippets/ce-product-card.liquid.
 *
 * The markup ships the second image with data-src / data-srcset and no
 * real source, so nothing is fetched at render. This promotes them the
 * first time a card is pointed at or focused. Rendering ~30 cards with a
 * live second source would have roughly doubled the homepage image
 * payload for images most visitors never see.
 *
 * Touch devices never load it: the CSS reveal is behind
 * (hover: hover) and (pointer: fine), so on a phone the bytes would buy
 * nothing. Same query is checked here so the fetch matches the reveal.
 *
 * Loaded by ce-just-in and ce-featured-grid, i.e. possibly twice on one
 * page, hence the init guard — two listeners would double every fetch.
 */
(() => {
  if (window.__ceCardHoverInit) return;
  window.__ceCardHoverInit = true;

  // Matches the CSS reveal in ce-theme.css. Keep the two in step.
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!canHover.matches) return;

  /**
   * Promote data-src/data-srcset to the real attributes, once.
   * @param {Element} media - the .ce-card__media element being entered
   */
  const revealAltImage = (media) => {
    const img = media.querySelector('.ce-card__img--alt[data-src]');
    if (!img) return;

    // srcset first: setting src alone would trigger a fetch of the
    // fallback before the candidate list is known.
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;

    // Drop the hooks so the element is skipped from here on.
    delete img.dataset.src;
    delete img.dataset.srcset;
  };

  /** @param {Event} event */
  const onEnter = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const media = target.closest('.ce-card__media');
    if (media) revealAltImage(media);
  };

  // pointerover rather than pointerenter: pointerenter does not bubble,
  // so it cannot be delegated, and these cards are re-rendered by the
  // Just In scroller. focusin covers keyboard traversal.
  document.addEventListener('pointerover', onEnter, { passive: true });
  document.addEventListener('focusin', onEnter, { passive: true });
})();
